export default {
    wap: `max-width: 750px`,
    pc: `min-width: 751px`,
}
